import { requests, mainApiRoot } from './index'

export const Billing = {
  changePlan: payload => requests.post(mainApiRoot, '/change-plan', payload),
  purchaseAddon: payload => requests.post(mainApiRoot, '/add-addon', payload),
  getInvoices: () => requests.get(mainApiRoot, '/account/invoices')
}
